import { useCallback, useEffect } from "react";
import { SENDER_TOWN_DOES_NOT_HAVE_DISTRICT, VISIT_OFFICE_DELIVERY_TYPE } from "../../../../data/static-data";
import SenderDistrictInput from "./SenderDistrictInput";
import { useSelector } from "react-redux";
import { selectCreatePopup } from "../../shipmentsSlice";

const SenderDistrictComponent = ({ state, setState }) => {
    const initialPopupState = useSelector(selectCreatePopup);

    const setDistrict = useCallback(
        (districtID) => {
            setState((prev) => {
                let newGettingPackageType = prev["getting-package-type"];
                if (prev["getting-package-type"] === "courier" && districtID === SENDER_TOWN_DOES_NOT_HAVE_DISTRICT) {
                    newGettingPackageType = VISIT_OFFICE_DELIVERY_TYPE;
                }

                let newDistrictID = districtID;
                if (!districtID) {
                    newDistrictID = prev["sender-district-id"];
                }
                if(districtID === SENDER_TOWN_DOES_NOT_HAVE_DISTRICT) {
                    newDistrictID = "";
                }

                if (
                    newGettingPackageType === prev["getting-package-type"] &&
                    newDistrictID === prev["sender-district-id"]
                ) {
                    return prev;
                }

                return {
                    ...prev,
                    "sender-district-id": newDistrictID,
                    "getting-package-type": newGettingPackageType,
                };
            });
        },
        [setState]
    );

    //Change district when is updated in popup initial state
    useEffect(() => {
        setDistrict(initialPopupState.senderDistrictID);
    }, [initialPopupState.senderDistrictID, setDistrict]);

    return (
        <SenderDistrictInput
            enabled={true}
            state={state["sender-district-id"]}
            setState={setDistrict}
            senderTownID={state["sender-town-id"]}
        />
    );
};

export default SenderDistrictComponent;
